


export class PublicationsView {

    viewedIds = new Set();
    
    constructor() {

        this.publicationList = document.querySelector('#publication-list');
        this.template = document.querySelector('#publication-template');

    }

    render(state) { 

        if (!(state && Object.keys(state).length > 0)) { return;}

        const data = state.data;

        if (data.years) { this.renderYears(data.years);}

        const container = this.publicationList;
        let current = container.nextElementSibling;

        let index = 0;
        while (current && current.classList.contains('li') && index < data.items.length) {

            const content = data.items[index];
            let publication = this.renderPartial(content);
            current.replaceWith(publication)

            current = publication.nextElementSibling;
            index += 1;
        }

        let next = container.nextElementSibling;
        while (next) {
            const current = next;
            next = next.nextElementSibling;

            if (
                current.classList.contains('li') &&
                current.querySelector('.dummy')
            ) {
                current.remove();
            }
        }
        


        const observer = new IntersectionObserver((entries, observer) => {

            entries.forEach(entry => {

                if (entry.isIntersecting) {

                    const el = entry.target;

                    this.viewedIds.add(el.dataset.id);

                    observer.unobserve(el);
                }
            });

        }, {
            root: null,
            rootMargin: '0px',
            threshold: 0.5
        });

        const articles = document.querySelectorAll('article.publication');
        articles.forEach(article => observer.observe(article));

        let timeout;
        window.addEventListener('scroll', () => {

            clearTimeout(timeout);
            timeout = setTimeout(() => {

                this.handleVisible();
            }, 500);
        });

    }

    renderYears(years) {

        const container = document.querySelector('.body.meta .ul');
        if (container) {
            container.innerHTML = '';

            const fragment = document.createDocumentFragment();

            years.forEach((item, index) => {
                const liDiv = document.createElement('div');
                liDiv.classList.add('li');
                if (item.isActive) {
                    liDiv.classList.add('active');
                }

                const link = document.createElement('a');
                link.href = item.url;

                const span = document.createElement('span');
                span.textContent = item.title;

                link.appendChild(span);
                liDiv.appendChild(link);
                fragment.appendChild(liDiv);
            });

            container.appendChild(fragment);
        }
    }
    
    renderPartial(publication) {

        const p = this.template.content.cloneNode(true);

        const article = p.querySelector('article.post');
        if (article) {
            article.dataset.id = publication.id;
            if (publication.classes && publication.classes.length > 0) {
                article.classList.add(...publication.classes);
            }
        }
        

        const imgWrapper = p.querySelector('.preview .img img');
        if (imgWrapper && publication.preview) {

            imgWrapper.src = publication.preview;

            imgWrapper.dataset.src = publication.preview;
            imgWrapper.alt = publication.title;

            p.querySelector('.preview').href = publication.url;

        } else {
            const previewLink = p.querySelector('.preview');
            if (previewLink) { previewLink.remove();}
        }



        const authorBlock = p.querySelector('.h');
        if (authorBlock) {

            const profileLink = authorBlock.querySelector('a');
            if (profileLink) {
                profileLink.href = publication.author.url;
            }

            const avatar = authorBlock.querySelector('img');
            if (avatar) {
                avatar.src = publication.author.avatar;
                avatar.alt = publication.author.username;
            }

            const username = authorBlock.querySelector('span');
            if (username) {
                username.textContent = publication.author.username;
            }

            const date = authorBlock.querySelector('.date');
            if (date) {
                date.textContent = publication.date;
            }
        }


        const titleLink = p.querySelector('.title a');
        if (titleLink) {
            titleLink.href = publication.url;
            titleLink.textContent = publication.title;
        }





        const ulContainer = p.querySelector('.post_tags .ul');
        if (publication.categories.length) {
            
            publication.categories.forEach((category, index) => {

                const div = document.createElement('div');
                div.classList.add('li', 'cat');
                div.dataset.id = category.id;

                const a = document.createElement('a');
                a.href = category.url;

                const span = document.createElement('span');
                span.textContent = category.title;

                a.appendChild(span);
                div.appendChild(a);

                ulContainer.appendChild(div);
            });
        }

        if (publication.tags.length) {

            publication.tags.forEach(tag => {

                const div = document.createElement('div');
                div.classList.add('li');

                const a = document.createElement('a');
                a.href = tag.url;

                const span = document.createElement('span');
                span.textContent = tag.title;

                a.appendChild(span);
                div.appendChild(a);

                ulContainer.appendChild(div);
            });
        }







        const anno = p.querySelector('.anno');
        if (anno) {
            if (publication.announce) {
                anno.textContent = publication.announce;
            } else {
                anno.remove();
            }
        }

        const counters = p.querySelector('.counters');
        if (counters) {
            const like = counters.querySelector('.ci.like span');
            if (like && publication.counters?.likes) {
                like.textContent = publication.counters.likes.value;
                if (publication.counters.likes.isActive) {
                    counters.querySelector('.ci.like').classList.add('toggled');
                }
            }

            const comments = counters.querySelector('.ci.comments span');
            if (comments && publication.counters?.comments) {
                comments.textContent = publication.counters.comments.value;


                const commentIcon = counters.querySelector('.ci.comments');
                const classes = publication?.counters?.comments?.classes;
                if (commentIcon && Array.isArray(classes) && classes.length) {
                    commentIcon.classList.add(...classes);
                }

                const commentLink = counters.querySelector('.ci.comments a');
                if (commentLink) { commentLink.href = publication.url + '#comments';}
            }

            const views = counters.querySelector('.ci.views span');
            if (views && publication.counters?.views) {
                views.textContent = publication.counters.views.value;
            }
        }

        const readButton = p.querySelector('.read_button');
        if (readButton) { readButton.href = publication.url;}

        return p.firstElementChild;

    }

    handleVisible() {

        if (!this.viewedIds.size) { return;}

        const viewedIds = [...this.viewedIds];
        this.viewedIds.clear();

        if (this.socket && this.socket.readyState == WebSocket.OPEN) {
            this.socket.send(JSON.stringify({
                eventId: 'publication.setPreview',
                payload: {
                    token: this.token,
                    publicationIds: viewedIds,
                }
            }));
        }
    }

    checkOverflow(box) {

        box.classList.remove('overflown');

        const ul = box.querySelector('.ul');
        if (!ul) { return;}

        let toggle = ul.querySelector('.overflow_toggle');

        const toggleWidth = 35; 
        const width = ul.clientWidth - toggleWidth;

        const items = Array.from(ul.children).filter(li =>
            li.classList.contains('li') && !li.classList.contains('overflow_toggle')
        );

        items.forEach(li => li.classList.remove('hidden'));

        items.forEach(li => {
            const left = li.offsetLeft;
            const liWidth = li.offsetWidth;

            if (left + liWidth > width) {
                li.classList.add('hidden');
            }
        });

        const hiddenCount = ul.querySelectorAll('.hidden').length;

        if (hiddenCount) {
            box.classList.add('overflown');

            if (!toggle) {
                toggle = document.createElement('div');
                toggle.className = 'li overflow_toggle';
                toggle.innerHTML = '<a><span></span></a>';
                ul.appendChild(toggle);
            }

            const span = toggle.querySelector('span');
            if (span) {
                span.textContent = '+' + hiddenCount;
            }
        }
    }
}